/*** IMPORTS FROM imports-loader ***/
var define = false;

const loadModals = () => {
    const modalButtons = document.querySelectorAll('[data-modal]')

    for (let i = 0; i < modalButtons.length; i++) {
        const button = modalButtons[i]
        const modalClass = button.dataset.modal
        const modal = document.querySelector(`.${modalClass}`)

        if (modal) {
            button.addEventListener('click', event => {
                event.preventDefault()
                document.body.classList.add('modal-visible')
                modal.classList.add('visible')
            })
        }
    }

    const modalCloseButtons = document.querySelectorAll('.modal-close')

    for (let i = 0; i < modalCloseButtons.length; i++) {
        const button = modalCloseButtons[i]
        const modal = button.parentNode.parentNode

        if (modal) {
            button.addEventListener('click', () => {
                document.body.classList.remove('modal-visible')
                modal.classList.remove('visible')
            })
        }
    }
}

export default loadModals




// WEBPACK FOOTER //
// ./js/modals.js